module.exports = __webpack_public_path__ + "media/images/pen_saddlebrown-9068f1c3.png";